<template>
  <div class="datum_ex">
    <van-cell-group v-for="item in orderList" :key="item.fileId">
      <van-cell :title="item.name" is-link @click="open(item.fileUrl)" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  props: ["orderList"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    open(url) {
      this.$router.push({path:'/preview',query:{url}})
    }
  }
};
</script>

<style>
.datum_ex {
  margin: 10px;
}
</style>